export default __webpack_public_path__ + "static/media/page-title-contacts-en.279801d5.svg";